import axios from "../axios-auth";

export const counterService = {
  getCountersByShopId
};

function getCountersByShopId(id) {
  return axios.get("auth/counters-by-shopId/" + id);
}
